import React from 'react'
import {connect} from "./../../../base/redux";
import { Avatar } from '../../../base/avatar';
import {_getAllParticipants} from "../JitsiMeet/actions"


function RaiseHandScreen(props) {
    let {_participants} = props;
    _participants = _participants.filter(value=>value.raisedHand);
    
    return (
        <>
        {_participants instanceof Array && _participants.length > 0 ? (
            <ul className="meet-participants-pop-screen raise-hand-pop-screen">
                {_participants.map((value, key) => {
                    return (
                        <li key={`raise_hand_${key}`} onClick={()=>$("#InviteModal").modal("show")}>
                            <div class="partcipant-pop-dt">
                                <span class="partcipant-img">
                                    <Avatar
                                        displayName = { value.name }
                                        size = { 48 }
                                        testId = 'knockingParticipant.avatar'
                                        url = { value.loadableAvatarUrl } />
                                </span>
                                <span class="participant-name"> 
                                    <h3>{value.name}</h3>
                                    <p>{value.name} has raised hand.</p>
                                </span>
                            </div>
                        </li>
                    );
                })}
            </ul>
        ) : null}
        </>
    )
}

const mapStateToProps = state => { 
    return {
        _participants: _getAllParticipants()
    }
}

export default connect(mapStateToProps)(RaiseHandScreen)
